import enterpriseReducers from '../../../web-sh/src/store/reducers/modules/enterprise'
import actionTypes from '../../actionTypes'
import initial from '../../initial'

const enterprise = (state = initial.enterprise, action) => {
  switch (action.type) {
  case actionTypes.SET_ENTERPRISE_INVITATIONS:
    return { ...state, enterpriseInvitations: action.payload }
  default:
    return enterpriseReducers(state, action)
  }
}

export default enterprise
